module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tablet@2x-2be25dc0c26575b27a4f2093b7844bb8.jpg";